import * as React from 'react';
import * as Redux from 'react-redux';
import { allModulosAction } from '../ModulosAction';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import SelectAutocomplete from '../../../../widgets/SelectAutocomplete';

const SelectFieldModulosComponent = ({
  onChange,
  value = '',
  data,
  id,
  isAll = true,
  isAllText = false,
  isEmpty = false,
  selects = [],
  isAutoComplete,
}) => {
  const dispatch = Redux.useDispatch();

  const modulosStore = Redux.useSelector((state) => state.modulos);

  const [modulos, setModulos] = React.useState([]);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      modulosStore.all.forEach((modulo) => {
        const existSeletc = selects.some((item) => item.id === modulo.id);
        if (!existSeletc) items.push(modulo);
      });
      setModulos(items);
    } else {
      if (data) {
        setModulos(data);
      } else {
        setModulos(modulosStore.all);
      }
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && modulosStore.all && modulosStore.all.length === 0) {
        await allModulosAction(dispatch, null);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(async () => _handlerSelects(), [selects]);

  const select = (
    <FormControl fullWidth size="small">
      <InputLabel id={`label_${id}`}>{CONST.modulo.label}</InputLabel>
      <Select
        id={id}
        value={value?.toString()}
        labelId={`label_${id}`}
        label={CONST.modulo.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {isEmpty ||
          (isAll && (
            <MenuItem key={`item_${id}_000`} value={null}>
              {isAll ? 'TODOS' : 'NINGUNO'}
            </MenuItem>
          ))}

        {isAllText && (
          <MenuItem key={`item_${id}_all`} value={'all'}>
            TODOS
          </MenuItem>
        )}
        {modulos.map((el, index) => {
          return (
            <MenuItem key={`item_${id}_${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );

  const autoComplete = (
    <SelectAutocomplete
      id={id}
      opt={modulos}
      v={value}
      type={CONST.modulo.name}
      onChange={(_, newValue) => onChange(newValue?.id)}
      l="Módulos"
    />
  );

  return isAutoComplete ? autoComplete : select;
};

export default SelectFieldModulosComponent;
